<template>
    <div class="choice-group" v-bind:class="{['variant-'+variant]: variant}">
        <div class="choice" :key="index" v-for="(choice, index) in choices" v-bind:class="{'active':choice.background===val}" v-bind:style="{'background': choice.background}" @click="makeActive(choice)"></div>
    </div>
</template>
<script>
    export default {
        name: 'ChoiceGroup',
        components: {},
        props: {
            choices: {
                type: Array
            },
            value: {
            },
            variant: {
                type: String,
                default: 'colors'
            }
        },
        data () {
            return {

            }
        },
        computed: {
            val: {
                // getter
                get: function () {
                    return this.value
                },
                // setter
                set: function (newValue) {
                    this.$emit('input', newValue);
                }
            }
        },
        mounted () {
            if(!this.value) {
                this.val = this.choices[0].background;
            }
        },
        methods: {
            makeActive: function(choice) {
                this.val = choice.background;
            }
        }
    }

</script>
<style src="./ChoiceGroup.scss" scoped lang="scss"></style>

